// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KnwY","fullView":"styles_fullView__3zslu"};